import { analytics } from 'moet-core';

export const ANALYTICS_EVENTS = {
  fillStoreDetails: new analytics.Event({
    name: 'Store Details Submitted',
    description: 'Merchant submits store details',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.FLOW_STEP,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: ['storeName', 'website', 'email', 'goodsCategory'],
    userAttributes: ['goodsCategory'],
  }),
};
